<template>
   <div class="popBg animate__animated animate__zoomIn" v-if="popShow" @click.stop="$emit('hiddlen')">
    <div class="popContent animate__animated animate__zoomIn" @click.stop="hiddlen1">
      <h3>{{title}}</h3>
      <div class="popInfo">
        <slot></slot>
        <div class="buttonBox" v-if="code||code==''">
          <img src="../assets/img/yt.png"/>
          <div class="btn up" @click="videoClick(0)"  v-preventRepeat="800"></div>
          <div class="btn bottom" @click="videoClick(1)"  v-preventRepeat="800"></div>
          <div class="btn left" @click="videoClick(2)"  v-preventRepeat="800"></div>
          <div class="btn right" @click="videoClick(3)"  v-preventRepeat="800"></div>
        </div>
      </div>
      <div class="close" @click.stop="$emit('hiddlen')"><img src="../assets/img/close.png" /></div>
    </div>
   </div>
</template>
<script>
import { ref, onMounted, reactive } from "vue";
import axios from "axios";
export default {
  name: "baseBar",
  props:['title','popShow','code'],
  setup(props) {
    console.log(props)
    const state = reactive({
      code:""
    })
    onMounted(() => {
     state.code = props.code
      
    });
    function videoClick(dir){
      console.log(state.code,dir)
      axios
        .post("https://zhfarm.laicunwang.com/api/environment/shangyunkong", {deviceSerial:state.code,direction:dir})
        .then((res) => {
          console.log(res)
        })
    }
    function hiddlen(){

    }
    return {
      hiddlen,
      videoClick
    };
  },
};

</script>
<style lang="less" scoped>
    .popBg{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0,0,0,.5);
      z-index: 10000;
      .popContent{
        width: 2384px;
        height: 1300px;
        background: url("../assets/img/tkbj.png") no-repeat;
        background-size: 100% 100%!important;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -650px;
        margin-left: -1192px;
        display: flex;
        flex-direction: column;
        padding-bottom: 100px;
        box-sizing: border-box;

        h3{
          font-size: 50px;
          color: #fff;
          line-height: 131px;
          background: url("../assets/img/tkbt.png") no-repeat;
          width: 1962px;
          height: 161px;
          box-sizing: border-box;
          margin: 0 auto;
        }
        .popInfo{
          width: 90%;
          flex: 1;
          margin-left: 5%;
          margin-top: 10px;
          overflow: hidden;
          .buttonBox{
            position: absolute;
            bottom: 160px;
            left: 50%;
            width: 296px;
            height: 296px;
            margin-left: -135px;
            z-index: 999;
            img{
              width: 100%;
              height: 100%;
            }
            .btn{
              position: absolute;
              width:96px;
              height: 96px;
              //border: 2px solid #f00;
              cursor: pointer;
            }
            .up{
              top: 0;
              left: 101.5px;
            }
            .bottom{
              bottom: 0;
              left: 101.5px;
            }
            .left{
              top: 101.5px;
              left: 0;
            }
            .right{
              top: 101.5px;
              right: 0;
            }
          }
        }
        .close{
          position: absolute;
          top: 80px;
          right: 80px;
          cursor: pointer;
          width: 78px;
          height: 53px;
        }
      }
    }
</style>
